module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.b4ca27a8.svg";